export default "__VITE_PUBLIC_ASSET__59a2b71b__"